import moment from 'moment'
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Modal from 'react-bootstrap/lib/Modal'
import Image from 'react-bootstrap/lib/Image'
import Button from 'react-bootstrap/lib/Button'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  registerSession,
  unregisterSession,
  hideEventDetails,
  fetchEvents,
  updateEvent,
  showEventDetails
} from '../actions/events.js'
import { showAttendeesModal } from '../actions/attendees.js'

import './EventDetails.css'

let hidden = null
let visibilityChange = null
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden'
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden'
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'
}

class EventDetails extends Component {
  static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    let account = this.props.account
    if (account) {
      dispatch(fetchEvents(account._id))
    }
    document.addEventListener(visibilityChange, this.handleVisibilityChange, false)
  }

  closeModal() {
    const { dispatch } = this.props
    dispatch(hideEventDetails())
    dispatch(fetchEvents(this.props.account._id))
  }

  registerSession(session) {
    const { dispatch } = this.props
    dispatch(registerSession(session, this.props.account))
  }

  unregisterSession(session) {
    const { dispatch } = this.props
    dispatch(unregisterSession(session, this.props.account))
  }

  showAttendeesModal(attendees) {
    const { dispatch } = this.props
    dispatch(showAttendeesModal(attendees))
  }

  handleVisibilityChange = () => {
    if (document[hidden]) {
      const { dispatch } = this.props
      let account = this.props.account
      if (account) {
        dispatch(fetchEvents(this.props.account._id))
      }
    } else {
      const { dispatch } = this.props
      let account = this.props.account
      // console.log('bar')
      if (account) {
        dispatch(fetchEvents(this.props.account._id))
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener(visibilityChange, this.handleVisibilityChange)
  }

  render() {
    if (!this.props.selectedEvent) {
      return <div />
    }

    let startDate = moment().startOf('day')
    let pastEvent = moment.utc(this.props.selectedEvent.eventDate).isBefore(startDate)

    let account = this.props.account
    let event = this.props.selectedEvent
    let sessions = event.sessions
    let duration = 0

    let attendees = []
    if (sessions.length > 0) {
      duration = sessions[0].duration

      for (var session of sessions) {
        if (session.attending) {
          for (var attendee of session.attending) {
            let existingAtendee = attendees.find(a => a._id === attendee._id)
            if (!existingAtendee) {
              attendees.push(attendee)
            }
          }
        }
      }
    }

    return (
      <div style={{ height: 120, width: 200 }}>
        <Modal className='eventDetails' show={this.props.selectedEvent} onHide={this.closeModal.bind(this)}>
          <Modal.Header closeButton={true} />
          <Modal.Body style={{ padding: '0px' }}>
            <div>
              <div class='eventDetailsContainer'>
                <Image style={{ minHeight: '250px', width: '100%' }} src={event.detailsImage} responsive />
                <div class='content'>
                  <h4>{event.eventLink.title}</h4>
                  <p>
                    {event.building ? event.building.name : ''}
                    <br />
                    {moment(event.eventDate).format('dddd, MMM D, YYYY')}
                  </p>
                </div>
              </div>

              <div class='eventDescription'>
                <p>Duration: {duration} mins</p>
                {event.location ? <p>Location : {event.location}</p> : <p />}
                <p style={{ whiteSpace: 'pre-line' }}>{event.eventLink.desc}</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div class='attendees-wrapper'>
              {attendees.length > 0 ? (
                <div class='eventAttendees'>
                  {attendees.slice(0, 4).map(attendee => {
                    return (
                      <div class='attendee-circle' onClick={this.showAttendeesModal.bind(this, attendees)}>
                        <span>
                          {attendee.image ? (
                            <Image
                              thumbnail
                              src={attendee.image}
                              onError={e => (e.target.src = '../images/guestAvatar.png')}
                              circle
                              className='avatar-image'
                            />
                          ) : (
                            <Image src='/images/guestAvatar.png' circle thumbnail className='avatar-image' />
                          )}
                        </span>
                      </div>
                    )
                  })}

                  <div class='attendees-count' onClick={this.showAttendeesModal.bind(this, attendees)}>
                    <img style={{ float: 'right', width: '20px', height: '20px' }} src='/images/next_icon.png' />

                    <div style={{ float: 'right' }}>
                      {attendees.length} {attendees.length == 1 ? 'attendee' : 'attendees'}
                    </div>
                  </div>
                </div>
              ) : (
                <div class='eventAttendees'>
                  <div class='text-center'>
                    <h4 style={{ marginTop: 0 }}>No Attendees</h4>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {pastEvent ? (
              <div class='text-center'>
                <h4>Not Bookable</h4>
              </div>
            ) : (
              <div>
                <div>
                  <div class='text-center'>
                    <h4>Attend at:</h4>
                  </div>
                </div>
                <div class='attend-sessions'>
                  {event.sessions
                    .sort((a, b) => (a.startDateTime > b.startDateTime ? 1 : -1))
                    .map(session => {
                      let attending = session.attending.map(a => a._id)
                      let attended = attending.indexOf(account._id) > -1
                      if (attended) {
                        /* functionalitatea care afiseaza cate locuri vacante au mai ramas : 3, 2, 1, full */
                        return (
                          <Button
                            className='unregister-session-button'
                            onClick={this.unregisterSession.bind(this, session)}>
                            {moment(session.startDateTime).format('h:mm a')}

                            {event.capacity - attending.length <= 3 ? (
                              <div style={{ fontSize: '13px', color: 'red' }}>
                                {event.capacity - attending.length == 0 ? (
                                  <div>event is full</div>
                                ) : (
                                  <div>seats left {event.capacity - attending.length}</div>
                                )}
                              </div>
                            ) : (
                              <div />
                            )}
                          </Button>
                        )
                      } else {
                        return (
                          <Button
                            className='register-session-button'
                            onClick={this.registerSession.bind(this, session)}>
                            {moment(session.startDateTime).format('h:mm a')}
                          </Button>
                        )
                      }
                    })}
                </div>
              </div>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return { ...state.eventsReducer, account: state.authReducer.account }
}

export default withRouter(connect(mapStateToProps)(EventDetails))



// WEBPACK FOOTER //
// ./src/components/EventDetails.js